// import React, { useEffect, useState } from "react";
// import { Box, Card, Typography, Grid } from "@mui/material";
// import { Bar, Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
// import axios from "axios";
 
// ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
 
// export default function AdminDashboard() {
//   const [dashboardData, setDashboardData] = useState({
//     single_participant_count: 0,
//     group_count: 0,
//     total_count_of_single_and_group_participants: 0,
//     investor_count: 0,
//     total_students: 0,
//     "AI/ML": 0,
//     "Real Estate": 0,
//     "Healthcare and Biotech": 0,
//     "E-commerce and Retail": 10,
//     "Education": 0,
//     "Finance and FinTech": 0,
//     "Energy and Sustainability": 0,
//     "Entertainment and Media": 0,
//     "Agriculture and Food": 0,
//     "Fashion and Lifestyle": 0,
//     "Others": 0,
//   });
 
//   useEffect(() => {
//     // Fetch data from API
//     axios
//       .get("https://newbackend.elephant-tank.com/api/admin_dashboard/")
//       .then((response) => {
//         setDashboardData(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching dashboard data:", error);
//       });
//   }, []);
 
//   const barChartData = {
//     labels: [
//       "AI/ML",
//       "Real Estate",
//       "Healthcare and Biotech",
//       "E-commerce and Retail",
//       "Education",
//       "Finance and FinTech",
//       "Energy and Sustainability",
//       "Entertainment and Media",
//       "Agriculture and Food",
//       "Fashion and Lifestyle",
//       "Others",
//     ],
//     datasets: [
//       {
//         label: "Projects by Type",
//         data: [
//           dashboardData["AI/ML"],
//           dashboardData["Real Estate"],
//           dashboardData["Healthcare and Biotech"],
//           dashboardData["E-commerce and Retail"],
//           dashboardData["Education"],
//           dashboardData["Finance and FinTech"],
//           dashboardData["Energy and Sustainability"],
//           dashboardData["Entertainment and Media"],
//           dashboardData["Agriculture and Food"],
//           dashboardData["Fashion and Lifestyle"],
//           dashboardData["Others"],
//         ],
//         backgroundColor: [
//           "#4caf50",
//           "#2196f3",
//           "#ff9800",
//           "#f44336",
//           "#9c27b0",
//           "#e91e63",
//           "#00bcd4",
//           "#673ab7",
//           "#ffc107",
//           "#009688",
//           "#795548",
//         ],
//         borderRadius: 8,
//       },
//     ],
//   };
 
//   const pieChartData = {
//     labels: ["Single Participants", "Groups", "Investors"],
//     datasets: [
//       {
//         data: [
//           dashboardData.single_participant_count,
//           dashboardData.group_count,
//           dashboardData.investor_count,
//         ],
//         backgroundColor: ["#4caf50", "#ff9800", "#2196f3"],
//         hoverOffset: 6,
//       },
//     ],
//   };
 
//   return (
//     <Box
//       sx={{
//         p: 4,
//         maxWidth: "1300px",
//         margin: "0 auto",
//         marginLeft:"20px",
//         marginRight:"20px",
//         marginTop: "80px",
//                 // background: "linear-gradient(to right, #ece9e6, #ffffff)",
//         borderRadius: 3,
//         boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
//       }}
//     >
//       <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
//         Admin Dashboard
//       </Typography>
 
//       {/* Top Summary Cards */}
//       <Grid container spacing={4} sx={{ mb: 4 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #4caf50, #8bc34a)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.single_participant_count}</Typography>
//             <Typography>Single Participants</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #ff9800, #ffcc80)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.group_count}</Typography>
//             <Typography>Groups</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #2196f3, #64b5f6)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.investor_count}</Typography>
//             <Typography>Investors</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #e91e63, #f06292)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.total_count_of_single_and_group_participants}</Typography>
//             <Typography>Total Count</Typography>
//           </Card>
//         </Grid>
//       </Grid>
 
//       {/* Charts */}
//       <Grid container spacing={4}>
//         <Grid item xs={12} md={6}>
//         <Card
//   sx={{
//     p: 3,
//     boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
//     background: "#ffffff",
//     borderRadius: 3,
//     height: "400px",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//   }}
// >
//   <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
//     Projects by Type
//   </Typography>
//   <Bar
//     data={barChartData}
//     options={{
//       maintainAspectRatio: false,
//       scales: {
//         x: {
//           type: 'category', // X-axis will display categories (project types)
//           title: {
//             display: true,
//             text: 'Project Types',
//           },
//         },
//         y: {
//           ticks: {
//             beginAtZero: true, // Start Y-axis from zero
//             stepSize: 1, // Display integer steps (1, 2, 3, etc.)
//             precision: 0, // Ensure no decimals are shown
//           },
//           title: {
//             display: true,
//             text: 'Number of Projects',
//           },
//         },
//       },
//     }}
//     style={{ height: "100%", width: "100%" }}
//   />
// </Card>
 
 
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <Card
//             sx={{
//               p: 3,
//               boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
//               background: "#ffffff",
//               borderRadius: 3,
//               height: "400px",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
//               Participant Distribution
//             </Typography>
//             <Pie
//               data={pieChartData}
//               options={{
//                 maintainAspectRatio: false,
//               }}
//               style={{ height: "100%", width: "100%" }}
//             />
//           </Card>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// }

// import React, { useEffect, useState } from "react";
// import { Box, Card, Typography, Grid } from "@mui/material";
// import { Bar, Pie } from "react-chartjs-2";
// import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
// import axios from "axios";
 
// ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);
 
// export default function AdminDashboard() {
//   const [dashboardData, setDashboardData] = useState({
//     single_participant_count: 0,
//     group_count: 0,
//     total_count_of_single_and_group_participants: 0,
//     investor_count: 0,
//     total_studens: 0,
    
//     "AI/ML": 0,
//     "Real Estate": 0,
//     "Healthcare and Biotech": 0,
//     "E-commerce and Retail": 10,
//     "Education": 0,
//     "Finance and FinTech": 0,
//     "Energy and Sustainability": 0,
//     "Entertainment and Media": 0,
//     "Agriculture and Food": 0,
//     "Fashion and Lifestyle": 0,
//     "Others": 0,
//   });
 
//   useEffect(() => {
//     // Fetch data from API
//     axios
//       .get("https://newbackend.elephant-tank.com/api/admin_dashboard/")
//       .then((response) => {
//         setDashboardData(response.data);
//       })
//       .catch((error) => {
//         console.error("Error fetching dashboard data:", error);
//       });
//   }, []);
 
//   const barChartData = {
//     labels: [
//       "AI/ML",
//       "Real Estate",
//       "Healthcare and Biotech",
//       "E-commerce and Retail",
//       "Education",
//       "Finance and FinTech",
//       "Energy and Sustainability",
//       "Entertainment and Media",
//       "Agriculture and Food",
//       "Fashion and Lifestyle",
//       "Others",
//     ],
//     datasets: [
//       {
//         label: "Projects by Type",
//         data: [
//           dashboardData["AI/ML"],
//           dashboardData["Real Estate"],
//           dashboardData["Healthcare and Biotech"],
//           dashboardData["E-commerce and Retail"],
//           dashboardData["Education"],
//           dashboardData["Finance and FinTech"],
//           dashboardData["Energy and Sustainability"],
//           dashboardData["Entertainment and Media"],
//           dashboardData["Agriculture and Food"],
//           dashboardData["Fashion and Lifestyle"],
//           dashboardData["Others"],
//         ],
//         backgroundColor: [
//           "#4caf50",
//           "#2196f3",
//           "#ff9800",
//           "#f44336",
//           "#9c27b0",
//           "#e91e63",
//           "#00bcd4",
//           "#673ab7",
//           "#ffc107",
//           "#009688",
//           "#795548",
//         ],
//         borderRadius: 8,
//       },
//     ],
//   };
 
//   const pieChartData = {
//     labels: ["Single Participants", "Groups", "Investors"],
//     datasets: [
//       {
//         data: [
//           dashboardData.single_participant_count,
//           dashboardData.group_count,
//           dashboardData.investor_count,
//         ],
//         backgroundColor: ["#4caf50", "#ff9800", "#2196f3"],
//         hoverOffset: 6,
//       },
//     ],
//   };
 
//   return (
//     <Box
//       sx={{
//         p: 4,
//         maxWidth: "1300px",
//         margin: "0 auto",
//         marginLeft:"20px",
//         marginRight:"20px",
//         marginTop: "80px",
//                 // background: "linear-gradient(to right, #ece9e6, #ffffff)",
//         borderRadius: 3,
//         boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
//       }}
//     >
//       <Typography
//         variant="h4"
//         sx={{
//           mb: 4,
//           fontWeight: "bold",
//           color: "#37474f",
//           textAlign: "center",
//         }}
//       >
//         Admin Dashboard
//       </Typography>
 
//       {/* Top Summary Cards */}
//       <Grid container spacing={4} sx={{ mb: 4 }}>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #4caf50, #8bc34a)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.single_participant_count}</Typography>
//             <Typography>Single Participants</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #ff9800, #ffcc80)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.group_count}</Typography>
//             <Typography>Groups</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #2196f3, #64b5f6)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.investor_count}</Typography>
//             <Typography>Investors</Typography>
//           </Card>
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <Card
//             sx={{
//               p: 3,
//               textAlign: "center",
//               background: "linear-gradient(135deg, #e91e63, #f06292)",
//               color: "white",
//               boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
//               borderRadius: 3,
//             }}
//           >
//             <Typography variant="h5">{dashboardData.total_studens}</Typography>
//             <Typography>Total Students</Typography>
//           </Card>
//         </Grid>
//       </Grid>
 
//       {/* Charts */}
//       <Grid container spacing={4}>
//         <Grid item xs={12} md={6}>
//         <Card
//   sx={{
//     p: 3,
//     boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
//     background: "#ffffff",
//     borderRadius: 3,
//     height: "400px",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     alignItems: "center",
//   }}
// >
//   <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
//     Projects by Type
//   </Typography>
//   <Bar
//     data={barChartData}
//     options={{
//       maintainAspectRatio: false,
//       scales: {
//         x: {
//           type: 'category', // X-axis will display categories (project types)
//           title: {
//             display: true,
//             text: 'Project Types',
//           },
//         },
//         y: {
//           ticks: {
//             beginAtZero: true, // Start Y-axis from zero
//             stepSize: 1, // Display integer steps (1, 2, 3, etc.)
//             precision: 0, // Ensure no decimals are shown
//           },
//           title: {
//             display: true,
//             text: 'Number of Projects',
//           },
//         },
//       },
//     }}
//     style={{ height: "100%", width: "100%" }}
//   />
// </Card>
 
 
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <Card
//             sx={{
//               p: 3,
//               boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
//               background: "#ffffff",
//               borderRadius: 3,
//               height: "400px",
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
//               Participant Distribution
//             </Typography>
//             <Pie
//               data={pieChartData}
//               options={{
//                 maintainAspectRatio: false,
//               }}
//               style={{ height: "100%", width: "100%" }}
//             />
//           </Card>
//         </Grid>
//       </Grid>
//     </Box>
//   );
// }
import React, { useEffect, useState } from "react";
import { Box, Card, Typography, Grid } from "@mui/material";
import { Bar, Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
import axios from "axios";

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default function AdminDashboard() {
  const [dashboardData, setDashboardData] = useState({
    single_participant_count: 0,
    group_count: 0,
    total_count_of_single_and_group_participants: 0,
    investor_count: 0,
    total_studens: 0,
    innovate_X_count_of_applicants: 0,
    "AI/ML": 0,
    "Real Estate": 0,
    "Healthcare and Biotech": 0,
    "E-commerce and Retail": 0,
    "Education": 0,
    "Finance and FinTech": 0,
    "Energy and Sustainability": 0,
    "Entertainment and Media": 0,
    "Agriculture and Food": 0,
    "Fashion and Lifestyle": 0,
    "Others": 0,
  });

  useEffect(() => {
    // Fetch data from API
    axios
      .get("https://newbackend.elephant-tank.com/api/admin_dashboard/")
      .then((response) => {
        setDashboardData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  }, []);

  const barChartData = {
    labels: [
      "AI/ML",
      "Real Estate",
      "Healthcare and Biotech",
      "E-commerce and Retail",
      "Education",
      "Finance and FinTech",
      "Energy and Sustainability",
      "Entertainment and Media",
      "Agriculture and Food",
      "Fashion and Lifestyle",
      "Others",
    ],
    datasets: [
      {
        label: "Projects by Type",
        data: [
          dashboardData["AI/ML"],
          dashboardData["Real Estate"],
          dashboardData["Healthcare and Biotech"],
          dashboardData["E-commerce and Retail"],
          dashboardData["Education"],
          dashboardData["Finance and FinTech"],
          dashboardData["Energy and Sustainability"],
          dashboardData["Entertainment and Media"],
          dashboardData["Agriculture and Food"],
          dashboardData["Fashion and Lifestyle"],
          dashboardData["Others"],
        ],
        backgroundColor: [
          "#4caf50",
          "#2196f3",
          "#ff9800",
          "#f44336",
          "#9c27b0",
          "#e91e63",
          "#00bcd4",
          "#673ab7",
          "#ffc107",
          "#009688",
          "#795548",
        ],
        borderRadius: 8,
      },
    ],
  };

  const pieChartData = {
    labels: ["Single Participants", "Groups", "Investors", "InnovateX Applicants"],
    datasets: [
      {
        data: [
          dashboardData.single_participant_count,
          dashboardData.group_count,
          dashboardData.investor_count,
          dashboardData.innovate_X_count_of_applicants,  // Added InnovateX Applicants
        ],
        backgroundColor: ["#4caf50", "#ff9800", "#2196f3", "#9c27b0"], // Added color for InnovateX
        hoverOffset: 6,
      },
    ],
  };

  return (
    <Box
      sx={{
        p: 4,
        maxWidth: "1300px",
        margin: "0 auto",
        marginLeft:"20px",
        marginRight:"20px",
        marginTop: "80px",
        borderRadius: 3,
        boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          mb: 4,
          fontWeight: "bold",
          color: "#37474f",
          textAlign: "center",
        }}
      >
        Admin Dashboard
      </Typography>

      {/* Top Summary Cards */}
      <Grid container spacing={4} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              p: 3,
              textAlign: "center",
              background: "linear-gradient(135deg, #4caf50, #8bc34a)",
              color: "white",
              boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              borderRadius: 3,
            }}
          >
            <Typography variant="h5">{dashboardData.single_participant_count}</Typography>
            <Typography>Single Participants</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              p: 3,
              textAlign: "center",
              background: "linear-gradient(135deg, #ff9800, #ffcc80)",
              color: "white",
              boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              borderRadius: 3,
            }}
          >
            <Typography variant="h5">{dashboardData.group_count}</Typography>
            <Typography>Groups</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              p: 3,
              textAlign: "center",
              background: "linear-gradient(135deg, #2196f3, #64b5f6)",
              color: "white",
              boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              borderRadius: 3,
            }}
          >
            <Typography variant="h5">{dashboardData.investor_count}</Typography>
            <Typography>Investors</Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              p: 3,
              textAlign: "center",
              background: "linear-gradient(135deg, #e91e63, #f06292)",
              color: "white",
              boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              borderRadius: 3,
            }}
          >
            <Typography variant="h5">{dashboardData.total_studens}</Typography>
            <Typography>Total Students</Typography>
          </Card>
        </Grid>
        {/* InnovateX Applicants Card */}
        <Grid item xs={12} sm={6} md={3}>
          <Card
            sx={{
              p: 3,
              textAlign: "center",
              background: "linear-gradient(135deg, #9c27b0, #e1bee7)",
              color: "white",
              boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              borderRadius: 3,
            }}
          >
            <Typography variant="h5">{dashboardData.innovate_X_count_of_applicants}</Typography>
            <Typography>InnovateX Applicants</Typography>
          </Card>
        </Grid>
      </Grid>

      {/* Charts */}
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
              background: "#ffffff",
              borderRadius: 3,
              height: "400px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
              Projects by Type
            </Typography>
            <Bar
              data={barChartData}
              options={{
                maintainAspectRatio: false,
                scales: {
                  x: {
                    type: 'category', // X-axis will display categories (project types)
                    title: {
                      display: true,
                      text: 'Project Types',
                    },
                  },
                  y: {
                    ticks: {
                      beginAtZero: true, // Start Y-axis from zero
                      stepSize: 1, // Display integer steps (1, 2, 3, etc.)
                      precision: 0, // Ensure no decimals are shown
                    },
                    title: {
                      display: true,
                      text: 'Number of Projects',
                    },
                  },
                },
              }}
              style={{ height: "100%", width: "100%" }}
            />
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              boxShadow: "0 12px 24px rgba(0,0,0,0.1)",
              background: "#ffffff",
              borderRadius: 3,
              height: "400px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, textAlign: "center" }}>
              Participant Distribution
            </Typography>
            <Pie
              data={pieChartData}
              options={{
                maintainAspectRatio: false,
              }}
              style={{ height: "100%", width: "100%" }}
            />
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
